<template>
  <div
    class="form-group"
    :class="{
      'has-error': errors.has(validationName),
      'form-group-active': active
    }"
  >
    <label class="control-label" v-if="label">{{ label }}</label>
    <select
      :key="componentKey"
      v-if="options"
      ref="select"
      class="form-control"
      :value="value"
      :name="name"
      :readonly="readonly"
      :disabled="disabled"
      :data-vv-as="label"
      @input="$emit('input', $event.target.value)"
      @change="$emit('input', $event.target.value)"
      @blur="changeFocus()"
      @focus="changeFocus()"
    >
      <option value>{{ placeholder }}</option>
      <option
        v-for="option in options"
        :key="option.value + option.text"
        :value="option.value"
        >{{ option.text }}</option
      >
    </select>
    <error-message :message="errors.first(validationName)"></error-message>
  </div>
</template>

<script>
export default {
  inject: ["$validator"],
  name: "form-group-select",
  props: {
    label: String,
    id: String,
    name: String,
    scope: String,
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    required: String,
    value: {
      type: [String, Number, Boolean, Object]
    },
    options: Array
  },
  mounted() {
    this.$el.value = this.value;
  },
  data() {
    return {
      active: false,
      componentKey: 0
    };
  },
  computed: {
    validationName() {
      return this.scope ? `${this.scope}.${this.name}` : this.name;
    }
  },
  methods: {
    changeFocus() {
      this.active = !this.active;
    }
  },
  watch: {
    options() {
      this.componentKey++;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/FormGroupSelect.vue